









import Vue from 'vue';

export default Vue.extend({
  name: 'VerticalNavigationSection',
  props: {
    title: { type: String, required: true },
  },
});
